// Copyright © 2021 Move Closer
export var NavVariant;
(function (NavVariant) {
    NavVariant["Underlined"] = "";
    NavVariant["Centered"] = "centered";
})(NavVariant || (NavVariant = {}));
